import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Loader } from "../../../../components";
import pages from "../../../../constants/pages";
import Table from "./email template list component/Table";
import { useAxios, useComponent } from "../../../../hooks";
import PageHeader from "./../../../../components/PageHeader";
import { apiComplete, startLoader } from "../../../../redux/slices/loaderSlice";

export default function EmailTemplateList({ pageID }) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { pagePermissions } = useComponent({ pageID });
  const { activeBot } = useSelector((state) => state.memberDetails);

  const [templates, setTemplates] = useState([]);
  const [templateDelete, setTemplateDelete] = useState("");

  useEffect(() => {
    dispatch(startLoader());

    axios({
      url: "/broadcast_email/template?agent_id=" + activeBot.ID,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setTemplates(response.data instanceof Array ? response.data : []);
      } else {
        setTemplates(response.data instanceof Array ? response.data : []);
      }
      dispatch(apiComplete());
    });
  }, [axios, templateDelete, dispatch, activeBot.ID]);

  return (
    <Loader>
      <PageHeader
        pageName="Templates"
        addIcon={[
          "Create Template",
          pages.emailTemplateCreate.route,
          pagePermissions.create,
        ]}
      />

      <Table
        templates={templates}
        setTemplates={setTemplates}
        agentID={activeBot.ID}
        setTemplateDelete={setTemplateDelete}
      />
    </Loader>
  );
}
